<template>
  <validation-provider
    class="col-span-1"
    tag="div"
    :name="fieldName"
    :rules="rules"
    mode="passive"
    v-slot="{ errors }"
  >
    <form-label :for="fieldName">
      Member ID Number
      <span v-if="isRequired" class="leading-none text-red-400">*</span>
    </form-label>
    <form-input
      :id="fieldName"
      v-model="internalValue"
      @input="onInput"
    ></form-input>
    <form-alert-msg v-if="errors[0]">{{ errors[0] }}</form-alert-msg>
    <template v-if="internalErrors">
      <form-alert-msg v-for="(error, index) in internalErrors" :key="index">{{
        error
      }}</form-alert-msg>
    </template>
  </validation-provider>
</template>

<script>
import { FormInput, FormLabel, FormAlertMsg } from "@/components/Form/";
import { ValidationProvider, extend } from "vee-validate";
import { required, max, min } from "vee-validate/dist/rules";
extend("required", { ...required, message: "This field is required." });
extend("max_member_num", {
  ...max,
  message: "This field may not be greater than 150 characters.",
});
extend("min_member_num", {
  ...min,
  message: "This field must be at least 3 characters.",
});

export default {
  components: {
    ValidationProvider,
    FormInput,
    FormLabel,
    FormAlertMsg,
  },
  props: ["value", "http-errors", "controls"],
  data() {
    return {
      internalValue: "",
    };
  },
  computed: {
    isRequired() {
      return (
        this.$store.state.config?.sameday ||
        this.$store.state.settings.insurance_fields.member_id_required
      );
    },
    fieldName() {
      return this.$vnode.key;
    },
    rules() {
      return this.isRequired
        ? "required|min_member_num:3|max_member_num:150"
        : "min_member_num:3|max_member_num:150";
    },
    internalErrors() {
      if (!this.httpErrors) return;
      return this.httpErrors.map((el) => el.replace(/input.insurance./i, ""));
    },
  },
  watch: {
    value: {
      handler(val) {
        this.internalValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input:field", val);
    },
  },
};
</script>
